module.exports = __webpack_public_path__ + "img/MedDrive-logo.e908712f.jpeg";